import { jsx as i, Fragment as _, jsxs as g } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { S as z } from "./index-DoOsnuB6.js";
import { c as f } from "./index-BNmRGtA6.js";
import { c as d } from "./clsx-OuTLNxxd.js";
import { S as y } from "./Spinner-LiIAKUHF.js";
import './Button.css';const x = "_buttonBase_1jg78_66", j = "_button_1jg78_66", h = "_xxSmallSize_1jg78_110", B = "_xSmallSize_1jg78_118", b = "_smallSize_1jg78_126", p = "_defaultSize_1jg78_134", v = "_largeSize_1jg78_140", F = "_iconSize_1jg78_148", N = "_primary_1jg78_157", W = "_secondary_1jg78_166", V = "_tertiary_1jg78_179", k = "_ghost_1jg78_201", w = "_ghostBrand_1jg78_202", C = "_outline_1jg78_242", R = "_surface_1jg78_255", q = "_isFullWidth_1jg78_261", A = "_rounded_1jg78_265", t = {
  buttonBase: x,
  button: j,
  xxSmallSize: h,
  xSmallSize: B,
  smallSize: b,
  defaultSize: p,
  largeSize: v,
  iconSize: F,
  primary: N,
  secondary: W,
  tertiary: V,
  ghost: k,
  ghostBrand: w,
  outline: C,
  surface: R,
  isFullWidth: q,
  rounded: A
}, D = f(t.button, {
  variants: {
    variant: {
      default: t.primary,
      ghost: t.ghost,
      ghostBrand: t.ghostBrand,
      secondary: t.secondary,
      tertiary: t.tertiary,
      outline: t.outline,
      surface: t.surface
    },
    size: {
      "xx-small": t.xxSmallSize,
      "x-small": t.xSmallSize,
      small: t.smallSize,
      default: t.defaultSize,
      large: t.largeSize,
      icon: t.iconSize
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), m = c(
  ({ asChild: l = !1, className: e, disabled: o, pressed: a, ...s }, n) => {
    const r = l ? z : "button", S = a === void 0 ? void 0 : { "aria-pressed": a, "data-state": a ? "on" : "off" };
    return /* @__PURE__ */ i(
      r,
      {
        className: d(t.buttonBase, e),
        "data-cxy-name": "button-base",
        disabled: o,
        ref: n,
        ...s,
        ...S
      }
    );
  }
), E = c(
  ({ asChild: l, isLoading: e, loadingText: o, variant: a, ...s }, n) => /* @__PURE__ */ i(_, { children: e ? /* @__PURE__ */ i(u, { ...s, "aria-busy": e, disabled: e, ref: n, variant: a, children: /* @__PURE__ */ g(_, { children: [
    o || "Loading",
    /* @__PURE__ */ i(y, { size: "s", variant: a === "secondary" ? "dark" : "light" })
  ] }) }) : /* @__PURE__ */ i(u, { ...s, asChild: l, ref: n, variant: a }) })
), u = c(
  ({ className: l, isFullWidth: e, rounded: o, size: a, variant: s, ...n }, r) => /* @__PURE__ */ i(
    m,
    {
      className: d(
        D({ variant: s, size: a }),
        { [t.isFullWidth]: e, [t.rounded]: o },
        l
      ),
      "data-cxy-name": "button",
      "data-testid": "button-component",
      ref: r,
      ...n
    }
  )
);
E.displayName = "Button";
m.displayName = "ButtonBase";
export {
  E as B,
  m as a,
  D as b
};
